module.exports = __webpack_public_path__ + "static/media/CLC_cover_01.a6264fb7.jpg";